import axios, { AxiosError } from "axios";
import { isDomain } from "../../utils/htmlReportsUtils";

let axiosInstance = null;

async function getAxiosInstance() {
  if (!axiosInstance) {
    axiosInstance = axios.create();

    axiosInstance.interceptors.request.use((config) => {
      if (!config?.headers?.["Content-Type"]) {
        config.headers["Content-Type"] = isDomain("researchcdn.nomuranow.com") ? "text/plain" : "application/json";
      }
      if (!config?.headers?.Accept) {
        config.headers.Accept = "application/json";
      }
      return config;
    });

    axiosInstance.interceptors.response.use(
      (response) => {
        const contentType = response.headers["content-type"] || "";
        if (contentType.includes("text/html")) {
          return Promise.reject(
            new AxiosError("Unexpected HTML response from API", "ERR_BAD_RESPONSE", response.config, response.request, {
              ...response,
              status: 500,
            }),
          );
        }

        if (response.request?.responseURL && !response.request.responseURL.endsWith(response.config.url)) {
          return Promise.reject(
            new AxiosError(
              "Unexpected redirection in API response",
              "ERR_BAD_RESPONSE",
              response.config,
              response.request,
              { ...response, status: 500 },
            ),
          );
        }

        return response;
      },
      (error) => Promise.reject(error),
    );
  }
  return axiosInstance;
}

export default getAxiosInstance;
